module.exports = __webpack_public_path__ + "static/iphone-c28494551050bb804ddfd04b94dc43c9.png";